import { TAuthType } from "@/lib/auth-type"
import { v4 as uuidV4 } from "uuid"
import { create } from "zustand"

/* -------------------------------------------------------------------------------------------------
 * types
 * -----------------------------------------------------------------------------------------------*/
type SignupRequestStoreData = {
  token: string
  basicToken: string
  tokenTouch: string
  initialHref: string
  sessionId: string
  fromPdv: boolean
  typUrl: string
  flagAdvPlus: boolean
  billCodeId?: string | null
  mppartner: string | null
  camid: string | null
  pid: string | null
  affid: string | null
  cliid: string | null
  phoneNumberAlreadyPresentCounter: number
  bonusCodeAlreadyPresentCounter: number
  pdvKoCheckCrendentialsCounter: number
  accountId: number | null
  promoCodeFromSearchParams?: string | null
  activePromoCode?: string | null
  intcmpFromSearchParams?: string
  hasSurveyBeenTriggered: boolean
  authType: TAuthType
}

type SignupRequestStore = {
  data: SignupRequestStoreData
  setData: (data: Partial<SignupRequestStoreData>) => void
  incrementPhoneAlreadyPresentCounter: () => void
  incrementPdvCheckCredentialsCounter: () => void
  reset: () => void
}

/* -------------------------------------------------------------------------------------------------
 * config
 * -----------------------------------------------------------------------------------------------*/

const initialState: SignupRequestStoreData = {
  token: "",
  tokenTouch: "",
  basicToken: btoa("sisalms:q1A2z3W4!"),
  initialHref: "",
  sessionId: uuidV4(),
  fromPdv: false,
  flagAdvPlus: false,
  typUrl: "",
  billCodeId: null,
  mppartner: null,
  camid: null,
  pid: null,
  affid: null,
  cliid: null,
  phoneNumberAlreadyPresentCounter: 0,
  bonusCodeAlreadyPresentCounter: 0,
  pdvKoCheckCrendentialsCounter: 0,
  accountId: null,
  promoCodeFromSearchParams: null,
  activePromoCode: null,
  intcmpFromSearchParams: undefined,
  hasSurveyBeenTriggered: false,
  authType: "sso",
}

/* -------------------------------------------------------------------------------------------------
 * store
 * -----------------------------------------------------------------------------------------------*/
const useSignupRequestStore = create<SignupRequestStore>((set) => ({
  data: initialState,
  setData: (data) => {
    set((state) => {
      state.data = { ...state.data, ...data }
      return state
    })
  },
  incrementPhoneAlreadyPresentCounter: () =>
    set((state) => ({
      ...state,
      data: {
        ...state.data,
        phoneNumberAlreadyPresentCounter:
          state.data.phoneNumberAlreadyPresentCounter + 1,
      },
    })),
  incrementPdvCheckCredentialsCounter: () =>
    set((state) => ({
      ...state,
      data: {
        ...state.data,
        pdvKoCheckCrendentialsCounter:
          state.data.pdvKoCheckCrendentialsCounter + 1,
      },
    })),
  reset: () => set({ data: initialState }),
}))

export type { SignupRequestStoreData }

export default useSignupRequestStore
